import { Box, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import cuideoTheme from "../../../../../../containers/themes/defaultTheme";
import LocationIcon from "../../../../../../assets/images/iconos/location.svg";

export const StyledAlert = styled(Alert)`
  padding: 0.25rem;
  background-color: rgba(248, 231, 28, 0.2);
  color: #f5a623;
  .MuiAlert-icon {
    padding: 0;
    margin-right: 0.25rem;
  }
  .MuiAlert-message {
    padding: 0;
    font-size: 0.75rem;
    line-height: 1;
  }
`;

export const StyledIcon = styled.img`
  display: block;
  height: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
  margin-top: 0.0625rem;
`;

export const StyledItemDetail = styled(Typography)`
  margin-top: 0;
  font-size: 0.75rem;
  line-height: 1.25;
  color: ${cuideoTheme.palette.primary.main};
`;

interface IServiceLocationProps {
  locality?: string;
  region?: string;
}

const ServiceLocation = (props: IServiceLocationProps) => {
  const { locality, region } = props;

  return (
    <Fragment>
      {!locality && !region ? (
        <StyledAlert severity="warning">
          <FormattedMessage
            id="ServiceCard.NoLocationWarning"
            defaultMessage="Sin información de ubicación"
          />
        </StyledAlert>
      ) : !locality ? (
        <Box display="flex">
          <StyledIcon src={LocationIcon}></StyledIcon>
          <StyledItemDetail>({region})</StyledItemDetail>
        </Box>
      ) : !region ? (
        <Box display="flex">
          <StyledIcon src={LocationIcon}></StyledIcon>
          <StyledItemDetail>{locality}</StyledItemDetail>
        </Box>
      ) : (
        <Box display="flex">
          <StyledIcon src={LocationIcon}></StyledIcon>
          <StyledItemDetail>
            {locality} ({region})
          </StyledItemDetail>
        </Box>
      )}
    </Fragment>
  );
};

export default ServiceLocation;
